import React from 'react';
import {
  Box,
  Container,
  Typography,
  Card,
  CardContent,
  Button,
  Grid,
  Avatar,
  Chip,
  TextField,
  InputAdornment,
} from '@mui/material';
import { Search, Add, FilterList } from '@mui/icons-material';
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';

const StaffManagement: React.FC = () => {
  const staff = [
    { id: 1, name: 'Sarah Johnson', role: 'Senior Nurse', department: 'ICU', email: 'sarah.j@hospital.com', status: 'active', shifts: 32 },
    { id: 2, name: 'Michael Chen', role: 'Nurse', department: 'ER', email: 'michael.c@hospital.com', status: 'active', shifts: 28 },
    { id: 3, name: 'Emily Davis', role: 'Charge Nurse', department: 'ICU', email: 'emily.d@hospital.com', status: 'on_leave', shifts: 24 },
    { id: 4, name: 'James Wilson', role: 'Nurse', department: 'Pediatrics', email: 'james.w@hospital.com', status: 'active', shifts: 30 },
    { id: 5, name: 'Lisa Brown', role: 'Nurse', department: 'ER', email: 'lisa.b@hospital.com', status: 'active', shifts: 26 },
  ];

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', bgcolor: '#f5f5f5' }}>
      <Sidebar />
      <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
        <Header />
        <Box component="main" sx={{ flex: 1, p: 3 }}>
          <Container maxWidth="xl">
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
              <Typography variant="h4" sx={{ fontWeight: 700 }}>
                Staff Management
              </Typography>
              <Box sx={{ display: 'flex', gap: 2 }}>
                <TextField
                  placeholder="Search staff..."
                  size="small"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Search />
                      </InputAdornment>
                    ),
                  }}
                  sx={{ width: 300 }}
                />
                <Button variant="outlined" startIcon={<FilterList />}>
                  Filter
                </Button>
                <Button variant="contained" startIcon={<Add />} sx={{ bgcolor: '#E91E63' }}>
                  Add Staff
                </Button>
              </Box>
            </Box>

            <Grid container spacing={3}>
              {staff.map((member) => (
                <Grid item xs={12} sm={6} md={4} lg={2.4} key={member.id}>
                  <Card sx={{ borderRadius: 3, textAlign: 'center' }}>
                    <CardContent>
                      <Avatar
                        sx={{ width: 80, height: 80, mx: 'auto', mb: 2, bgcolor: '#E91E63' }}
                      >
                        {member.name.charAt(0)}
                      </Avatar>
                      <Typography variant="h6" sx={{ fontWeight: 600 }}>
                        {member.name}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {member.role}
                      </Typography>
                      <Chip
                        label={member.department}
                        size="small"
                        sx={{ mt: 1, mb: 2 }}
                        variant="outlined"
                      />
                      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                        <Typography variant="caption" color="text.secondary">
                          Shifts: {member.shifts}
                        </Typography>
                        <Chip
                          label={member.status}
                          size="small"
                          color={member.status === 'active' ? 'success' : 'warning'}
                        />
                      </Box>
                      <Button variant="outlined" fullWidth size="small">
                        View Profile
                      </Button>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Container>
        </Box>
      </Box>
    </Box>
  );
};

export default StaffManagement;
